module.exports = __webpack_public_path__ + "static/media/swiftlogo.e2202b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/swiftlogo.png
// module id = 827
// module chunks = 0